import { DiscoverList } from '../components';
import { DiscoverListTabEnum } from '../components/discover-list';

const DiscoverFollow = () => {
  return <DiscoverList tab={DiscoverListTabEnum.Follow} />;
};

export default DiscoverFollow;
